import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import lists from '@/components/lists'
import show from '@/components/show'
import merchant from '@/components/merchant'
import merchantshow from '@/components/Merchantshow'
import merchantjoin from '@/components/merchantjoin'
import search from '@/components/search'
import help from '@/components/help'
import registered from '@/components/registered'
import usercenter from '@/components/usercenter'
import editprofile from '@/components/editprofile'
import publish from '@/components/publish'
import myinfo from '@/components/myinfos'
import myfavorite from '@/components/myfavorite'
import upgrade from '@/components/upgrade'
import logout from '@/components/logout'

import login from '@/components/Login'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: index
    },
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/lists',
      name: 'lists',
      component: lists
    },
    {
      path: '/show',
      name: 'show',
      component: show
    },
    {
      path: '/merchant',
      name: 'merchant',
      component: merchant
    },
    {
      path: '/merchantshow',
      name: 'merchantshow',
      component: merchantshow
    },
    {
      path: '/merchantjoin',
      name: 'merchantjoin',
      component: merchantjoin
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/help',
      name: 'help',
      component: help
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/registered',
      name: 'registered',
      component: registered
    },
    {
      path: '/usercenter',
      name: 'usercenter',
      component: usercenter
    },
    {
      path: '/editprofile',
      name: 'editprofile',
      component: editprofile
    },
    {
      path: '/publish',
      name: 'publish',
      component: publish
    },
    {
      path: '/myinfo',
      name: 'myinfo',
      component: myinfo
    },
    {
      path: '/myfavorite',
      name: 'myfavorite',
      component: myfavorite
    },
    {
      path: '/upgrade',
      name: 'upgrade',
      component: upgrade
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js